import { render, staticRenderFns } from "./DashboardHeading.vue?vue&type=template&id=2c788865&"
import script from "./DashboardHeading.vue?vue&type=script&lang=js&"
export * from "./DashboardHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports